import { getColumns } from '@thoughtspot/chart-lib/lib/core/chart-model-utils';
import {
    shouldShowDataLabelToggleForColumn,
    shouldShowDetailLabelToggleForColumn,
} from '@thoughtspot/chart-lib/lib/core/chart-type-specification-service';
import { CLIENT_STATE_KEYS } from '@thoughtspot/client-state-util';
import _ from 'lodash';
import {
    AnswerColumn,
    ChartViz as ChartModel,
    ChartVizProps,
} from '/@services/generated/graphql-types';
import {
    getUpdatedClientState,
    VizColumnProperties,
} from './client-state.util';

export function toggleAllDataLabel(
    chart: any,
    chartModel: ChartModel,
    enabled: boolean,
): ChartVizProps {
    const columns: AnswerColumn[] = getColumns(chartModel);
    let vizProp = _.cloneDeep(chartModel.vizProp);
    vizProp.chartProperties = {
        ...vizProp.chartProperties,
        allLabels: enabled,
        showStackedLabels: enabled,
    };

    columns.forEach((col: AnswerColumn) => {
        const columnId = col.id;
        const shouldShowDataLabel = shouldShowDataLabelToggleForColumn(
            chartModel,
            columnId,
        );
        const shouldShowDetailLabel = shouldShowDetailLabelToggleForColumn(
            chartModel,
            columnId,
        );
        if (shouldShowDataLabel || shouldShowDetailLabel) {
            vizProp = getUpdatedClientState(
                CLIENT_STATE_KEYS.columnProperties,
                {
                    id: VizColumnProperties.updateDatalabel,
                    columnId,
                    enabled,
                },
                vizProp,
            ) as ChartVizProps;
        }
    });

    return vizProp;
}
